import { useState } from "react";
import { X, Check } from "@phosphor-icons/react";
import { PIN_COLORS, PIN_EMOJIS } from "@/lib/session";

export default function PinPicker({ open, color, emoji, name, onSave, onClose }) {
  const [c, setC] = useState(color || PIN_COLORS[0]);
  const [e, setE] = useState(emoji || "");
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[82] flex items-end justify-center bg-black/60 sm:items-center" data-testid="pin-picker">
      <div className="w-full max-w-md border-2 border-black bg-white shadow-[8px_8px_0px_rgba(0,0,0,1)]">
        <div className="flex items-center justify-between border-b-2 border-black bg-secondary px-4 py-3 text-white">
          <h2 className="font-heading text-base font-black uppercase tracking-tight">Your pin</h2>
          <button data-testid="pin-picker-close" onClick={onClose} className="grid h-9 w-9 place-items-center border-2 border-black bg-primary text-black">
            <X weight="bold" size={18} />
          </button>
        </div>

        <div className="p-4">
          {/* preview */}
          <div className="mb-4 flex items-center gap-3 border-2 border-black bg-background p-3">
            <span
              className="grid h-12 w-12 shrink-0 place-items-center rounded-full border-2 border-black text-2xl"
              style={{ background: c }}
              data-testid="pin-preview"
            >
              {e}
            </span>
            <div>
              <p className="font-heading text-lg font-black uppercase leading-none">{name}</p>
              <p className="font-mono2 text-[10px] font-bold uppercase tracking-widest text-black/50">This is how your crew sees you</p>
            </div>
          </div>

          <p className="mb-2 font-mono2 text-xs font-bold uppercase tracking-[0.2em] text-black/50">Colour</p>
          <div className="mb-4 flex flex-wrap gap-2">
            {PIN_COLORS.map((col) => (
              <button
                key={col}
                data-testid={`pin-color-${col.replace("#", "")}`}
                onClick={() => setC(col)}
                className={`h-10 w-10 rounded-full border-2 border-black transition-transform duration-150 ease-out ${c === col ? "scale-110 shadow-[3px_3px_0px_rgba(0,0,0,1)]" : ""}`}
                style={{ background: col }}
                aria-label={col}
              >
                {c === col && <Check weight="bold" size={16} className="mx-auto text-white drop-shadow" />}
              </button>
            ))}
          </div>

          <p className="mb-2 font-mono2 text-xs font-bold uppercase tracking-[0.2em] text-black/50">Emoji (optional)</p>
          <div className="mb-5 flex flex-wrap gap-2">
            {PIN_EMOJIS.map((em, i) => (
              <button
                key={i}
                data-testid={`pin-emoji-${i}`}
                onClick={() => setE(em)}
                className={`grid h-10 w-10 place-items-center border-2 border-black text-xl shadow-[2px_2px_0px_rgba(0,0,0,1)] transition-transform duration-150 ease-out active:translate-x-[2px] active:translate-y-[2px] active:shadow-none ${e === em ? "bg-primary" : "bg-white"}`}
              >
                {em === "" ? <span className="font-mono2 text-[9px] font-bold uppercase">None</span> : em}
              </button>
            ))}
          </div>

          <button
            data-testid="pin-save"
            onClick={() => onSave({ color: c, emoji: e })}
            className="flex h-14 w-full items-center justify-center gap-2 border-2 border-black bg-primary font-heading text-base font-bold uppercase shadow-[4px_4px_0px_#18181B] transition-transform duration-150 ease-out active:translate-x-[3px] active:translate-y-[3px] active:shadow-none"
          >
            Save my pin
          </button>
        </div>
      </div>
    </div>
  );
}
